import { render } from "./DepartureSchedule.vue?vue&type=template&id=689430e4&ts=true"
import script from "./DepartureSchedule.vue?vue&type=script&lang=ts"
export * from "./DepartureSchedule.vue?vue&type=script&lang=ts"

import "./DepartureSchedule.vue?vue&type=style&index=0&id=689430e4&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__